var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('div',[_c('fields-list',{attrs:{"item":_vm.item,"fields":_vm.fields},on:{"change":_vm.updateItem}}),_c('hr'),_c('h5',[_vm._v("Ученики:")]),_c('clients',{attrs:{"clients":_vm.item.clients,"id":_vm.id,"discipline_id":_vm.item.discipline_id,"lessonplan_id":_vm.lessonplan_id,"defaultWork":_vm.defaultWork}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }